import type { Plugin } from 'vue';
import { url } from '@vuelidate/validators';
import type { QueryClient } from '@tanstack/vue-query';

import { i18n } from '@/i18n/i18n';
import PageTitle from '@/plugins/page-title';
import VueQuery from '@/plugins/vueQuery';

export default {
  install(app, options?: { queryClient?: QueryClient }) {
    app.use(i18n);
    url.$message = i18n.global.t('global.validation.url');

    app.use(VueQuery, options?.queryClient);

    app.use(PageTitle);
  },
} satisfies Plugin;
